<template>
<v-form v-model="valid" @submit.prevent='dologin' >
<v-card tile outlined class='elevation-20' >
  <v-card-title
    v-if='withHeader'
    class='subtitle-1 overline orange white--text' >
    <v-icon dark class='mr-3' >mdi-lock</v-icon>
    Please login
  </v-card-title>
  <v-divider></v-divider>
  <v-card-text class='pt-10' >
    <request-status :request='request.login' />
    <v-text-field filled required v-model="email" type='email' label='email' />
    <v-text-field filled required v-model='password' label='password' type='password' />
  </v-card-text>
  <!-- R: {{ redirectPath }} | {{isLoggedIn}} -->
  <v-card-actions >
    <slot name='actions-left' ></slot>
    <v-spacer ></v-spacer>
    <v-btn color='primary' :disabled='!valid' :loading='request.login.loading' type='submit' >Login</v-btn>
  </v-card-actions>
  <v-divider></v-divider>
  <v-footer >
    <v-btn @click='$emit("forgot", email)' x-small text >
    Forgot password
    </v-btn>
  </v-footer>
</v-card>
</v-form>
</template>
<script>
import {mapGetters} from 'vuex'
// import {AUTH_CLIENT_ID, AUTH_CLIENT_SECRET} from '@/store/constants.js'

export default {
  name: 'LoginView',
  props: {
    withHeader: { type: Boolean, default: true },
    withRedirect: { type: Boolean, default: true }
  },
  data () {
    return {
      valid: false,
      email: null,
      password: null,
      request: {
        login: { resource: 'auth.login' }
      }
    }
  },
  computed: {
    ...mapGetters(
        'auth', [
        'redirectPath',
        'isLoggedIn'
      ]
    ),
    url () {
      return process.env.VUE_APP_AUTHENTICATIONGURU_API_ROOT
    },
    requestStatus () {
      return this.request.login.status
    }
  },
  watch: {
    requestStatus () {
      if (this.requestStatus === 200) {
        let path = this.redirectPath
        let token = this.getObjectPath(this.request.login, 'result.access_token')
        this.$store.dispatch('auth/logUserIn', token)

        window.setTimeout(() => {
          this.$emit('success', this.request.login.result)
          if (this.withRedirect) {
            if (this.$route.path !== path) {
              this.$router.push({path})
            }
          }
        }, 500)
      }
    },
    email () {
      this.$emit('update:email', this.email)
    }
  },
  methods: {
    dologin () {
      this.request.login.data = {
        username: this.email,
        password: this.password,
        client_id: process.env.VUE_APP_CLIENT_ID,
        client_secret: process.env.VUE_APP_CLIENT_SECRET
      }
      this.$request('save', this.request.login)
    }
  }
}
</script>
